import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Heading from './Heading'
import { useTranslation } from 'react-i18next'
import OfferTableHeading from './Common/OfferTableHeading'
import useFilterOffers from './Common/useFilterOffers'
import { useSelector } from 'react-redux'
import { selectOrganizationsSelectedProvider, selectOrganizationsRoutes } from '../organizationsManagementSelectors'
import { useSnackbarNotification } from '@/shared/tools/notifications/useSnackbarNotification'
import { SNACKBAR_TYPES } from '@/shared/tools/notifications/notification'
import { OuterContainer, Block, BlockTitle } from '../styled-components'

const ProviderShow = ({ OffersTableComponent }) => {
  const selectedProvider = useSelector(selectOrganizationsSelectedProvider)
  const routes = useSelector(selectOrganizationsRoutes)
  const showNotification = useSnackbarNotification()
  const [filteredOffers, setFilteredOffers] = useState(selectedProvider.offers ?? [])
  const { t } = useTranslation()
  const { filterOffers } = useFilterOffers({ offers: selectedProvider.offers, setFilteredOffers })

  useEffect(() => {
    setFilteredOffers(selectedProvider.offers)
    filterOffers(0)
  }, [selectedProvider.offers])

  return (
    <OuterContainer>
      <Heading />
      {selectedProvider.uuid && (
        <>
          <Block key='infos'>
            <BlockTitle>{t('organizationManagement:provider_info')}</BlockTitle>
            <p key='name'>
              {t('organizationManagement:name')} : {selectedProvider.name}
            </p>
            <p key='zoho_prefix'>
              {t('organizationManagement:general_info.zoho_prefix')} : {selectedProvider.zoho_prefix}
            </p>
          </Block>

          <Block key='offer_table'>
            <OfferTableHeading t={t} onClick={filterOffers} />
            {filteredOffers && filteredOffers.length > 0 && (
              <OffersTableComponent
                items={filteredOffers}
                providerUuid={selectedProvider.uuid}
                deleteRoute={routes.offers.delete}
                duplicateRoute={routes.offers.duplicate}
                onDeleteSuccess={() => showNotification({ type: SNACKBAR_TYPES.SUCCESS, message: t('organizationManagement:offerDeleted') })}
                onDuplicateSuccess={() => showNotification({ type: SNACKBAR_TYPES.SUCCESS, message: t('organizationManagement:offerDuplicated') })}
              />
            )}
          </Block>
        </>
      )}
    </OuterContainer>
  )
}

ProviderShow.propTypes = {
  OffersTableComponent: PropTypes.elementType.isRequired,
}

export default ProviderShow
